/* Native details keeps the mobile menu usable without JavaScript. */
document.querySelectorAll('[data-nuvia-shop-nav]').forEach((menu) => {
  const summary = menu.querySelector('summary');
  document.addEventListener('click', (event) => {
    if (menu.open && (!menu.contains(event.target) || event.target.closest('a'))) menu.open = false;
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu.open) { menu.open = false; summary.focus(); }
  });
  window.matchMedia('(min-width: 961px)').addEventListener('change', (event) => {
    if (event.matches) menu.open = false;
  });
});
